/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * User access information including cross-tenant roles
 * @export
 * @interface UserAccessDto
 */
export interface UserAccessDto {
    /**
     * User ID
     * @type {string}
     * @memberof UserAccessDto
     */
    userId?: string;
    /**
     * Role ID
     * @type {string}
     * @memberof UserAccessDto
     */
    roleId?: string;
    /**
     * Role name
     * @type {string}
     * @memberof UserAccessDto
     */
    roleName?: string;
    /**
     * Source tenant ID for cross-tenant roles
     * @type {string}
     * @memberof UserAccessDto
     */
    sourceTenantId?: string;
    /**
     * Relationship ID for cross-tenant roles
     * @type {string}
     * @memberof UserAccessDto
     */
    relationshipId?: string;
    /**
     * When the role was assigned
     * @type {Date}
     * @memberof UserAccessDto
     */
    assignedAt?: Date;
    /**
     * When the role assignment expires
     * @type {Date}
     * @memberof UserAccessDto
     */
    expiresAt?: Date;
    /**
     * Whether the role assignment is active
     * @type {boolean}
     * @memberof UserAccessDto
     */
    active?: boolean;
    /**
     * Reason for the role assignment
     * @type {string}
     * @memberof UserAccessDto
     */
    assignmentReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessDto
     */
    crossTenant?: boolean;
}

/**
 * Check if a given object implements the UserAccessDto interface.
 */
export function instanceOfUserAccessDto(value: object): value is UserAccessDto {
    return true;
}

export function UserAccessDtoFromJSON(json: any): UserAccessDto {
    return UserAccessDtoFromJSONTyped(json, false);
}

export function UserAccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'sourceTenantId': json['sourceTenantId'] == null ? undefined : json['sourceTenantId'],
        'relationshipId': json['relationshipId'] == null ? undefined : json['relationshipId'],
        'assignedAt': json['assignedAt'] == null ? undefined : (new Date(json['assignedAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'active': json['active'] == null ? undefined : json['active'],
        'assignmentReason': json['assignmentReason'] == null ? undefined : json['assignmentReason'],
        'crossTenant': json['crossTenant'] == null ? undefined : json['crossTenant'],
    };
}

export function UserAccessDtoToJSON(json: any): UserAccessDto {
    return UserAccessDtoToJSONTyped(json, false);
}

export function UserAccessDtoToJSONTyped(value?: UserAccessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'sourceTenantId': value['sourceTenantId'],
        'relationshipId': value['relationshipId'],
        'assignedAt': value['assignedAt'] == null ? undefined : ((value['assignedAt']).toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'active': value['active'],
        'assignmentReason': value['assignmentReason'],
        'crossTenant': value['crossTenant'],
    };
}

